@use "../../../../scss/variables" as *;
@use "../../../../scss/mixins" as *;

.Overlay {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;

  z-index: 5;
}

.Value {
  font-size: 16px;
  line-height: 22px;
  font-weight: 400;

  color: var(--primary-color);
}

.Select {
  &Clip {
    position: absolute;
    left: calc(var(--x) * 1px);
    top: calc(var(--y) * 1px);
    transform: translateX(-50%);

    padding: 2rem;
  }

  overflow: hidden;

  min-width: 114px;
  border-radius: 8px;

  padding: 0.25rem 0;

  display: flex;
  flex-direction: column;

  background-color: var(--surface-color);
  box-shadow: var(--menu-box-shadow);
}

.Option {
  position: relative;
  height: 40px;
  overflow: hidden;

  font-size: 16px;
  font-weight: 400;

  display: flex;
  align-items: center;
  justify-content: center;
  padding-inline: 0.75rem;

  color: var(--primary-text-color);

  cursor: pointer;

  &.selected {
    color: var(--primary-color);
  }

  @include hover-global(filled-gray, background-color);
}
